import React, { FC, useState } from 'react'
import { I18n } from 'aws-amplify'
import { makeStyles, Theme, Grid, Typography } from '@material-ui/core'

import { PillButton } from 'components'
import { AuthFlowSteps } from 'types'
import { AboutEventModal } from './AboutEventModal'

import { ReactComponent as ISLogo } from 'assets/5GIS-black.svg'

interface SignInProps {
  setAuthState: (state: AuthFlowSteps) => void
}

export const AuthRoot: FC<SignInProps> = ({ setAuthState }) => {
  const classes = useStyles()

  const [aboutModalOpen, setAboutModalOpen] = useState<boolean>(false)

  const signIn = () => {
    setAuthState(AuthFlowSteps.SignIn)
  }

  const register = () => {
    setAuthState(AuthFlowSteps.Register)
  }

  return (
    <Grid container direction='column' justify='center'>
      <Grid item className={classes.headerContainer}>
        <ISLogo className={classes.ISLogo} />
        <Typography variant='h1' component='h1' className={classes.hideElement}>
          5G Innovation Sessions
        </Typography>
        <Typography variant='h3' component='h2' dangerouslySetInnerHTML={{ __html: I18n.get('joinUsRoot') }} />
      </Grid>
      <Grid item container alignItems='flex-start' spacing={2} className={classes.buttonContainer}>
        <Grid item>
          <PillButton onClick={() => signIn()} className={classes.button} solid>
            {I18n.get('signIn')}
          </PillButton>
        </Grid>
        <Grid item>
          <PillButton onClick={register} className={classes.button}>
            {I18n.get('register')}
          </PillButton>
        </Grid>
      </Grid>
      <Grid item>
        <Typography>
          <span>{I18n.get('review')}</span>
          <span className={classes.agendaLink} onClick={() => setAboutModalOpen(true)}>
            {I18n.get('detailsAndAgenda')}
          </span>
        </Typography>
      </Grid>
      <AboutEventModal open={aboutModalOpen} onClose={() => setAboutModalOpen(false)} />
    </Grid>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    width: 165
  },
  logoImage: {
    width: 413
  },
  headerContainer: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '60%'
    }
  },
  agendaLink: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  buttonContainer: {
    marginTop: '2.5rem',
    marginBottom: '1.5rem'
  },
  ISLogo: {
    height: 216,
    marginBottom: '1rem',
    [theme.breakpoints.down('lg')]: {
      height: 168
    },
    [theme.breakpoints.down('md')]: {
      height: 162
    },
    [theme.breakpoints.down('sm')]: {
      height: 140
    }
  },
  hideElement: {
    border: 0,
    clip: 'rect(1px, 1px, 1px, 1px)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1
  }
}))
